import React, { useState, useEffect } from "react";
import "./Timer.css";

const Timer = ({ onChange }) => {
  const [seconds, setSeconds] = useState(5);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    let interval = null;
    interval = setInterval(() => {
      setSeconds((seconds) => seconds - 1);
    }, 1000);
    if (seconds === 0) {
      clearInterval(interval);
      onChange();
    }
    return () => clearInterval(interval);
  }, [isActive, seconds]);

  return (
    <React.Fragment>
      <div className="ptur-timer-container">
        <div className={"ptur-timer-btn c-latex30 bgc-white rb18l"}>{seconds}s</div>
      </div>
    </React.Fragment>
  );
};

export default Timer;
